import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import DataTable from '../../shared/components/DataTable';
import {
  reporteInscriptos,
  downloadStudentsInscriptos,
} from '../../redux/actions/studentsActions';
import { fetchFormDatas } from '../../redux/actions/periodoActions';
import { createErrorMessage } from '../../helpers/notification';

class StudentsContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 100,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: {
        id: 20,
        periodo: { value: 0, label: '-' },
      },
      periods: [],
    };
    this.columns = [
      {
        key: 'periodo',
        name: 'Periodo',
        className: 'text-center',
        search: true,
        width: '200px',
        type: 'select',
        searchProps: {
          options: this.getPeriods,
        },
        format: row => `${row.periodo ? row.periodo.label : '-'}`,
      },
      {
        key: 'malla',
        name: 'Malla',
        search: true,
      },
      {
        key: 'carrera',
        name: 'Carrera',
        search: true,
      },
      {
        key: 'numeroLegajo',
        name: '# Legajo',
        width: '110px',
        search: true,
        type: 'number',
      },
      {
        key: 'numeroDocumento',
        name: '# Documento',
        search: true,
        type: 'number',
        width: '130px',
      },
      {
        key: 'nombre',
        name: 'Nombre',
        search: true,
      },
      {
        key: 'apellido',
        name: 'Apellido',
        search: true,
      },
      {
        key: 'cantidadDeMateriasActuales',
        name: 'Cantidad de materias',
        type: 'number',
        width: '150px',
        className: 'text-center',
      },
    ];
  }

  componentDidMount() {
    this.fetchDatasList();
  }

  fetchDatasList = () => {
    this.setState({
      loading: true,
    });

    fetchFormDatas({
      onSuccess: ({ periodos }) => {
        this.setState({
          periods: periodos,
          loading: false,
        });

        const { page, pageSize } = this.state;
        this.updateStudentsTable(page, pageSize);
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  updateStudentsTable = (page, pageSize, filters = {}) => {
    const { periodo = {} } = filters;

    this.setState({
      loading: true,
      page,
      pageSize,
      filters: {
        ...filters,
        periodoId: periodo.value,
      },
    });
    reporteInscriptos({
      pageInfo: {
        page,
        pageSize,
        filters: {
          ...filters,
          periodoId: periodo.value,
        },
      },
      onSuccess: (pageInfo) => {
        this.setState({
          loading: false,
          items: pageInfo.items,
          totalItemsCount: pageInfo.totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de alumnos');
      },
    });
  }

  editStudent = (student) => {
    const { history } = this.props;
    history.push(`/pages/students/edit/${student.id}`);
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateStudentsTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateStudentsTable(1, pageSize, values);
    }
  };


  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateStudentsTable(1, pageSize, {});
  };

  getPeriods = () => {
    const { periods } = this.state;

    return periods || [];
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  downloadAlumnos = () => {
    const { filters } = this.state;
    downloadStudentsInscriptos({
      filters: filters || {},
      onError: () => {
        createErrorMessage('Error al intentar descargar la lista de alumnos');
      },
    });
  }


  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Reporte de alumnos</h3>
          </Col>
        </Row>
        {items.length && (
          <Row>
            <Col md={12} className="text-right">
              <button
                className="btn btn-link"
                type="button"
                onClick={this.downloadAlumnos}
              >
                <span className="fa fa-cloud-download">&nbsp;</span>
                Descargar lista
              </button>
            </Col>
          </Row>
        )
        }
        <Row>
          {loading ? <Col md={12}><h3 className="page-subhead subhead">Cargando...</h3></Col>
            : (
              <DataTable
                title="Reporte de los alumnos inscriptos al periodo actual"
                columns={this.columns}
                items={items}
                onChangePage={this.onChangePage}
                page={page}
                pageSize={pageSize}
                totalItemsCount={totalItemsCount}
                onSubmit={this.onDataTableSubmit}
                onClearFilters={this.onDataTableClearFilters}
                initialValues={filters}
                enableReinitialize
              />
            )
          }
        </Row>
      </Container>
    );
  }
}

export default withRouter(StudentsContainer);
